export const MAX_NUMBER_OF_ICONS_IN_AVATAR_GROUP = 4;
